/**
 * courses页面配置
 */
export default {
  /**
   * 新业务系统通用文案配置
   */
  gradeTitle: 'Grade',
  termTitle: 'Semester',
  lessonUnit: 'lesson',
  perLesson: '/lesson',
  lessonUnitTxt: '{0} lesson{1}',
  leftTxt: 'left',
  lessonLeft: '{1} lesson{2} {0}',
  lessonStarted: '{0} lesson{1} started',
  courseEnded: 'Course ended',
  suitableFor: 'Suitable for',
  from: 'From',
  noAddress: 'No address',
  classStore: '1 Space | {store} Spaces',
  // -------------------
  procedureTitle: '3 Steps to Start Your Learning Journey',
  step: 'Step {index}',
  procedureStep: [
    {
      cls: 'desktop-outline',
      themeColor: '#ccc',
      title: 'Sign up for the course',
      des:
      'Click "Enroll" into the course you are interested in.',
    },
    {
      cls: 'access-course-details',
      themeColor: '#ccc',
      title: 'Access course details',
      des: 'Check your mailbox for course attendance details and course materials.',
    },
    {
      cls: 'attend-the-class',
      themeColor: '#ccc',
      title: 'Attend the class',
      des:
    'Enter the classroom 10 minutes before the class and enjoy your Think Academy experience.',
    },

  ],
  bannerList: [
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/0-us-courses-banner-web.jpg',
      url: '/courses/detail/promote/14441',
      target: '',
    },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/1-k-courses.jpg',
      url: '/courses/detail/promote/13960',
      target: '',
    },
    // {
    //   src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/2-all-star-camp.jpg',
    //   url: '/courses/detail/promote/13804',
    //   target: '',
    // },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/3-g5-algebra.jpg',
      url: '/courses/detail/promote/13922',
      target: '',
    },
    {
      src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/pc/courses/4-dual-teacher.jpg',
      url: '/1-to-1-assessment',
      target: '',
    },
  ],
  inclusive: '',

  // 商城首页课程卡片文案配置
  courseCard: {
    levelDegreeMore: 'Different levels available',
    learnMore: 'Learn more',
    lowPricePrefix: 'From',
    lowPriceTailfix: '',
  },
  filter: {
    day: 'Day',
    time: 'Time',
    level: 'Level',
    grade: 'Grade',
  },
  fillIinformation: {
    title: 'If there is no class that meets your requirments, please fill in your information:',
    form: {
      group: 'Child’s Year Group',
      day: 'Day',
      time: 'Time',
      email: 'Your email',
      name: 'Your name',
      agree: 'Sign up for our mailing list to receive the latest news, promotions and updates!',
      submit: 'Submit',
    },
  },
}
